import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { graphql } from "gatsby"
import Pagehero from "../components/pagehero"
import Homemap from "../components/homemap"
import HomeProjects from "../components/homeprojects"
import HomeCities from "../components/homecities"
import Support from "../components/support"
import GetInvolvedBlock from "../components/get-involved-block"
import StoryCardList from "../components/storycardlist"
import { calculateProjectStats } from "../utils/projectStats"

const IndexPage = ({ location, data }) => {
  const cities = data.allMdx.nodes
  const stories = data.allPrismicNews.edges
  const projectStats = calculateProjectStats(data)

  // Client-side sorting by publication_date (in descending order)
  const sortedStories = [...stories].sort((a, b) => {
    const dateA = new Date(a.node.data.publication_date)
    const dateB = new Date(b.node.data.publication_date)
    return dateB - dateA // For descending order
  })

  return (
    <Layout>
      <Pagehero
        location={location}
        title_1={content.title_1}
        heroIntro={content.heroIntro}
      />
      <Homemap />
      <HomeProjects projectStats={projectStats} />
      <HomeCities stories={cities} />
      <GetInvolvedBlock />
      <div className="px-5 md:p-0">
        <StoryCardList stories={sortedStories} />
      </div>
      <Support />
    </Layout>
  )
}

export const Head = () => (
  <Seo title="Great Bike Infrastructure Project | PeopleForBikes" />
)

export default IndexPage

const content = {
  title_1: "Better Biking In Your Backyard",
  heroIntro:
    "PeopleForBikes’ Great Bike Infrastructure Project invests in communities across the U.S. to create safer and more connected places to bike for people of all ages and abilities.",
}

export const query = graphql`
  query storiesQuery {
    allMdx(sort: { frontmatter: { order: ASC } }) {
      nodes {
        frontmatter {
          title
          slug
          hero {
            childImageSharp {
              gatsbyImageData
            }
          }
          hero_alt
          city
          state
          region
          city_rating
          city_ranking
          city_percentile
          city_us_rank
          city_region_rank
          city_state_rank
          tag
          order
        }
        id
      }
    }

    allPrismicNews(
      filter: {
        data: {
          infrastructure_story: { eq: true }
          publication_date: { gte: "2022-12-31" }
        }
      }
    ) {
      edges {
        node {
          data {
            title {
              text
            }
            header_image {
              url
              alt
            }
            publication_date
            deck
            byline
          }
          uid
          id
          type
        }
      }
    }

    allGoogleSheetRow {
      nodes {
        Status
        Type
      }
      totalCount
    }
  }
`
